export default {"src":"/_next/static/media/info.f6cb62f9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};